<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-medium-size-100">
      <md-field>
        <vue_select
          class="vue-select2"
          name="select_cliente"
          :options="items_clientes"
          v-model="data_cliente.id_cliente"
          v-bind:onChange="change_value"
          :searchable="true"
          language="pt-BR"
          :placeholder="place_holder_cliente"
        ></vue_select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-30 md-medium-size-60">
      <md-field>
        <md-input
          name="filtro_cidade"
          type="text"
          placeholder="Cidade da Unidade"
          @keyup.enter="enter"
          v-model="data_cliente.estabelecimento"
        ></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-20 md-medium-size-40">
      <md-field>
        <md-input
          name="filtro_estado"
          type="text"
          placeholder="Estado"
          @keyup.enter="enter"
          v-model="data_cliente.estado"
        ></md-input>
      </md-field>
    </div>
  </div>
</template>
<script>
import vue_select from "../../components/Rend/vue-select/src/Select.vue";

import serviceCliente from "../../services/ClienteService";

import Util from "../../library/Util";
export default {
  components: {
    vue_select
  },
  components: {
    vue_select
  },
  props: {
    data_cliente: {
      default() {
        return { id_cliente: null, estabelecimento: "", estado: "" };
      },
      type: Object
    },
    onEnter: {
      default() {
        return null;
      },
      type: Function
    }
  },
  watch: {
    data_cliente: {
      deep: true,
      handler: function(val) {
        this.$emit("input", this.data_cliente);
      }
    }
  },
  data() {
    return {
      items_clientes: [],
      place_holder_cliente: "..Carregando lista de clientes"
    };
  },
  model: {
    prop: "value",
    event: "input"
  },
  mounted() {
    let self = this;

    serviceCliente.getList("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(response.data, "id", "nome");
      self.place_holder_cliente = "Cliente (digite para pesquisar)";
    });
  },
  methods: {
    change_value() {
      this.$emit("input", this.data_cliente);
    },
    enter(e) {
      if (this.onEnter != null) {
        this.onEnter(e);
      }
    }
  }
};
</script>